import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomVendorReportingUtils } from '../../custom-vendor-reporting-utils';
import {
  ReportTransferStatus,
  VendorReportTransferData,
  VendorReportingManufacturers
} from '../../custom-vendor-reporting.models';
import { CustomCanonVendorReportingDetailsComponent } from '../custom-canon-vendor-reporting-details/custom-canon-vendor-reporting-details.component';
import { CustomVendorReportingService } from '../../custom-vendor-reporting.service';

@Component({
    selector: 'app-custom-vendor-reporting-details',
    templateUrl: './custom-vendor-reporting-details.component.html',
    styleUrls: ['./custom-vendor-reporting-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomVendorReportingDetailsComponent implements OnInit {
  @Input() reportTransferData: VendorReportTransferData;
  reportTransferStatusEnum = ReportTransferStatus;
  manufaturerSpecificDetailsComponent: any;
  isRioEmployee=this.vendorReportingService.getIsRioEmployee;


  constructor(public modal: NgbActiveModal,private vendorReportingService: CustomVendorReportingService) {}

  ngOnInit(): void {
    this.manufaturerSpecificDetailsComponent =
      this.getManufacturerSpecificDetailsComponent(
        this.reportTransferData.manufacturer
      );
  }

  getReportTransferStatusColor(status: ReportTransferStatus): string {
    return CustomVendorReportingUtils.getReportTransferStatusColor(status);
  }

  private getManufacturerSpecificDetailsComponent(manufacturer: string): any {
    if (manufacturer === VendorReportingManufacturers.CANON) {
      return CustomCanonVendorReportingDetailsComponent;
    }
  }
}
